module.exports = __webpack_public_path__ + "img/LsgAudio5-9.a650a03a.jpeg";